import { Injectable } from '@angular/core';
import { RpcClientService } from './rpc-client.service';

@Injectable({
  providedIn: 'root'
})
export class RenderOtxCandidateService {

  constructor(
    private rpcClientService: RpcClientService
  ) { }


  tryFDTConnection(appId: any, queueId: any) {

    var params = {
      "applicationId": appId, //"G1697900", //"G1697900",//appId,
      "queueId": queueId,//"1627477083000VINWF0EXXWPCEFL10444", //"1627465613000VINWF0EXXWPCEFL10444", //"1627451916000VINWF0EXXWPCEFL10444", //queueId,
      "applicationType": "DiagnosticTest", //applicationParams.applicationType,
      "functionType": "vehicle.software.functiontype.unknown", //applicationParams.functionType,
      "complexTool": "false" // applicationParams.complexTool
    };
    //if (this.rpcClientService.isFdrsConnected())
    if (this.rpcClientService.getConnectionStatus() == this.rpcClientService.connectionStatus.CONNECTED) {
      //fdrsClient.getFdtUtil().startApplication(params);
      this.rpcClientService.startApplication(params);
    }
    // else
    // {
    //     fdrsClient.initFdrsClient(params);
    // }
  }

}
